<template>
  <div id="app" :class="isPC ? 'pc' : ''">
    <!-- <Home v-if="isPC"></Home> -->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keep"></router-view>
    </keep-alive> -->
    <router-view></router-view>

  </div>
</template>

<script>
import { isPc } from "@/util/index"
import { init } from "@/proxy/index"
export default {
  // components: {
  //   Home: () => import("@/views/home")
  // },
  computed: {
    isPC () {
      return isPc()
    }
  },
  created () {
    let result = {
      headIconList: [],
      dmg_headIconList: [],
      yt: '',
      google: '',
      ios: '',
      news: [],
      bannerList: [],
      faq: [],
      faqs: [],
      showFaq: false,
      policy1: '',
      policy2: '',
      yuyue: true,
      is_can_submit: '',
    }
    init().then(res => {
      if (res.data.code == 0) {
        const data = res.data.data;
        (data.platform || []).map(i => {
          result.headIconList.push({
            icon: i.pic_url,
            url: i.jump_url
          })
        })
        ;(data.dmg_platform || []).map(i => {
          result.dmg_headIconList.push({
            icon: i.pic_url,
            url: i.jump_url
          })
        })

        result.floatBanner = data.floatBanner || {};
        result.yt = data.index.public_video

        if (data.index.is_can_submit == 'yes') {
          result.yuyue = true
        } else {
          result.yuyue = false
        }

        result.is_can_submit = data.index.is_can_submit;


        // 正式上线后的下载链接
        result.google = data.index.download_google
        result.ios = data.index.download_appstore
        // 预约阶段的下载链接
        result.submit_ios = data.index.submit_appstore
        result.submit_google = data.index.submit_google

        // 预注册页的双端链接
        result.double_link = data.index.double_link

        if (data.channel_article && data.channel_article.length > 0) {
          result.news = data.channel_article
        }

        data.banner.map(i => {
          result.bannerList.push(i.pic_url)
        })

        result.showFaq = data.faq.is_open == 'yes' ? true : false

        if (data.faq.data) {

          if (data.faq.data[0]) {
            result.faq.push(data.faq.data[0])
          }

          if (data.faq.data[1]) {
            result.faq.push(data.faq.data[1])
          }

          result.faqs = data.faq.data
        }


        // result.policy1 = data.agreement.protect

        // result.policy2 = data.agreement.rule

        result.order = data.order

        this.$store.dispatch('setMyData', result)
      }
    })
  },
  mounted () {
    document.querySelector("#loadingMask").style.display = "none";
  }
};
</script>

<style lang="scss">
  body{
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    font-family: 'jpft', Arial, Helvetica, sans-serif;
    width: 100%;
    &::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    // min-width: 1600px;
    // width: 100%;
    // position: fixed;
    // height: 100vh;
  }

  #app{
    width: 100%;
    position: relative;
    overflow: hidden;
    &.pc {
      min-width: 1600px;
    }
  }

</style>
